/* Florescer — comportamentos da Home no tema Craft.
   Sem dependências externas. Nada é adicionado ao objeto window.
   Toda inicialização acontece no connectedCallback e é idempotente. */
(function () {
  'use strict';

  var REDUCED = '(prefers-reduced-motion: reduce)';

  function prefersReduced() {
    return typeof matchMedia === 'function' && matchMedia(REDUCED).matches;
  }

  /* Rolagem curta e controlada até o elemento, respeitando movimento reduzido. */
  function shortScroll(element) {
    if (!element) return;
    var offset = 80;
    var start = window.scrollY;
    var target = Math.max(0, element.getBoundingClientRect().top + start - offset);

    if (prefersReduced()) {
      window.scrollTo(0, target);
      return;
    }
    var duration = 420;
    var t0 = performance.now();
    function tick(now) {
      var p = Math.min((now - t0) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      window.scrollTo(0, start + (target - start) * eased);
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function escapeHtml(value) {
    var node = document.createElement('div');
    node.textContent = value == null ? '' : String(value);
    return node.innerHTML;
  }

  /* Lê com segurança um <script type="application/json"> interno. */
  function readJson(root, selector) {
    var node = root.querySelector(selector);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || 'null');
    } catch (error) {
      if (window.console && console.warn) {
        console.warn('[Florescer] Configuração JSON inválida em ' + selector, error);
      }
      return null;
    }
  }

  /* ---------------------------------------------------------------
     Jeitos de brincar — os seis cards permanecem sempre disponíveis.
     Os resultados são renderizados pelo Liquid (dados reais do Shopify);
     o JavaScript apenas alterna qual painel fica visível.
  ---------------------------------------------------------------- */
  class FlorescerWays extends HTMLElement {
    connectedCallback() {
      if (this.dataset.flReady === 'true') return;
      this.dataset.flReady = 'true';

      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-fl-way]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-fl-way-panel]'));
      if (!this.cards.length || !this.panels.length) return;

      this.panels.forEach(function (panel) {
        panel.hidden = true;
      });

      this.onCardClick = this.onCardClick.bind(this);
      this.onBackClick = this.onBackClick.bind(this);

      this.cards.forEach(function (card) {
        card.addEventListener('click', this.onCardClick);
      }, this);

      this.querySelectorAll('[data-fl-choose-another]').forEach(function (button) {
        button.addEventListener('click', this.onBackClick);
      }, this);
    }

    disconnectedCallback() {
      if (this.dataset.flReady !== 'true') return;
      this.cards.forEach(function (card) {
        card.removeEventListener('click', this.onCardClick);
      }, this);
      this.querySelectorAll('[data-fl-choose-another]').forEach(function (button) {
        button.removeEventListener('click', this.onBackClick);
      }, this);
      this.dataset.flReady = 'false';
    }

    onCardClick(event) {
      var card = event.currentTarget;
      var path = card.getAttribute('data-path');
      var panel = this.panels.filter(function (item) {
        return item.getAttribute('data-path') === path;
      })[0];
      if (!panel) return;

      this.cards.forEach(function (item) {
        item.setAttribute('aria-pressed', String(item === card));
      });
      this.panels.forEach(function (item) {
        item.hidden = item !== panel;
      });

      requestAnimationFrame(function () {
        shortScroll(panel);
      });
    }

    onBackClick() {
      var active = this.cards.filter(function (card) {
        return card.getAttribute('aria-pressed') === 'true';
      })[0];
      if (active) {
        shortScroll(active);
        active.focus({ preventScroll: true });
      }
    }
  }

  /* ---------------------------------------------------------------
     Encontre o ideal — compra guiada em 2 perguntas:
     objetivo (campo florescer.objetivos) -> subopção (gestos).
     Não há pergunta de kit/individual. Diretos primeiro, demais
     produtos do mesmo objetivo em área separada, sem pontuação.
  ---------------------------------------------------------------- */

  /* Normaliza texto para comparação (sem acento, minúsculo, sem espaços extras). */
  function flChave(value) {
    return String(value == null ? '' : value)
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .trim()
      .toLowerCase();
  }

  class FlorescerFinder extends HTMLElement {
    connectedCallback() {
      if (this.dataset.flReady === 'true') return;
      this.dataset.flReady = 'true';

      var data = readJson(this, '[data-fl-data]');
      this.heading = this.querySelector('[data-fl-heading]');
      this.question = this.querySelector('[data-fl-question]');
      this.options = this.querySelector('[data-fl-options]');
      this.result = this.querySelector('[data-fl-finder-result]');
      this.topActions = this.querySelector('[data-fl-top-actions]');

      if (!data || !this.heading || !this.question || !this.options || !this.result) {
        if (this.options) this.options.hidden = true;
        return;
      }

      this.labels = data.labels || {};
      this.objetivos = Array.isArray(data.objetivos) ? data.objetivos : [];
      this.items = Array.isArray(data.items) ? data.items : [];
      if (!this.objetivos.length || !this.items.length) {
        this.options.hidden = true;
        return;
      }

      this.reset();

      this.onOptionClick = this.onOptionClick.bind(this);
      this.options.addEventListener('click', this.onOptionClick);

      var adjusts = Array.prototype.slice.call(this.querySelectorAll('[data-fl-adjust]'));
      var restarts = Array.prototype.slice.call(this.querySelectorAll('[data-fl-restart]'));
      if (adjusts.length) {
        this.onAdjust = function () {
          this.step = 1;
          this.render();
        }.bind(this);
        adjusts.forEach(function (adjust) { adjust.addEventListener('click', this.onAdjust); }, this);
      }
      if (restarts.length) {
        this.onRestart = function () {
          this.reset();
          this.render();
        }.bind(this);
        restarts.forEach(function (restart) { restart.addEventListener('click', this.onRestart); }, this);
      }

      this.render();
    }

    disconnectedCallback() {
      if (this.dataset.flReady !== 'true') return;
      if (this.options && this.onOptionClick) this.options.removeEventListener('click', this.onOptionClick);
      this.dataset.flReady = 'false';
    }

    reset() {
      this.step = 0;
      this.objetivo = null;
      this.subopcao = null;
    }

    itemsOfObjetivo() {
      var value = flChave(this.objetivo && this.objetivo.value);
      return this.items.filter(function (item) {
        return (item.objetivos || []).some(function (objetivo) {
          return flChave(objetivo) === value;
        });
      });
    }

    recommend() {
      var alvos = ((this.subopcao && this.subopcao.gestos) || []).map(flChave);
      return this.itemsOfObjetivo()
        .map(function (item) {
          var gestos = (item.gestures || []).map(flChave);
          var direto = alvos.length === 0 || alvos.some(function (alvo) {
            return gestos.indexOf(alvo) !== -1;
          });
          var relevancia = 0;
          if (alvos.indexOf(flChave(item.main)) !== -1) relevancia += 3;
          if ((item.objetivos || []).length <= 1) relevancia += 1;
          if (item.available) relevancia += 2;
          if (item.image) relevancia += 1;
          return { item: item, direto: direto, relevancia: relevancia };
        })
        .sort(function (a, b) {
          return (
            Number(b.direto) - Number(a.direto) ||
            b.relevancia - a.relevancia ||
            a.item.title.localeCompare(b.item.title, 'pt-BR')
          );
        });
    }

    card(item, heading) {
      var tag = heading || 'h4';
      var image = item.image
        ? '<img class="fl-product__image" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy" width="600" height="750">'
        : '<span class="fl-product__image fl-product__image--empty"></span>';
      var soldOut = item.available === false ? '<span class="fl-product__tag">Esgotado</span>' : '';
      return (
        '<a class="fl-product" href="' + escapeHtml(item.url) + '">' +
        '<span class="fl-product__media">' + image + soldOut + '</span>' +
        '<' + tag + ' class="fl-product__title">' + escapeHtml(item.title) + '</' + tag + '>' +
        '<p class="fl-product__price">' + escapeHtml(item.price) + '</p>' +
        '</a>'
      );
    }

    onOptionClick(event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var button = target.closest('button');
      if (!button || !this.options.contains(button)) return;

      if (button.hasAttribute('data-fl-back')) {
        this.step = Math.max(0, this.step - 1);
        this.render();
        return;
      }
      var value = button.getAttribute('data-value');
      if (value == null) return;

      if (this.step === 0) {
        var self = this;
        this.objetivo =
          this.objetivos.filter(function (objetivo) {
            return objetivo.id === value;
          })[0] || null;
        this.subopcao = null;
        if (!this.objetivo) return;
        this.step = 1;
        this.render();
        return;
      }

      if (this.step === 1) {
        var subopcoes = (this.objetivo.subopcoes || []).concat([
          { id: 'sem-preferencia', rotulo: this.labels.noPreference || 'Não tenho preferência', gestos: [] }
        ]);
        this.subopcao =
          subopcoes.filter(function (subopcao) {
            return subopcao.id === value;
          })[0] || null;
        if (!this.subopcao) return;
        this.showResult();
      }
    }

    render() {
      this.result.hidden = true;
      if (this.topActions) this.topActions.hidden = true;
      this.heading.textContent = this.labels.inputTitle || '';
      this.options.hidden = false;
      this.options.innerHTML = '';
      var html = '';

      if (this.step === 0) {
        this.question.textContent = this.labels.questionPath || '';
        this.objetivos.forEach(function (objetivo) {
          html +=
            '<button class="fl-option" type="button" data-value="' + escapeHtml(objetivo.id) + '">' +
            '<strong>' + escapeHtml(objetivo.title) + '</strong></button>';
        });
      }

      if (this.step === 1 && this.objetivo) {
        this.question.textContent = this.objetivo.pergunta || '';
        var subopcoes = (this.objetivo.subopcoes || []).concat([
          { id: 'sem-preferencia', rotulo: this.labels.noPreference || 'Não tenho preferência', gestos: [] }
        ]);
        subopcoes.forEach(function (subopcao) {
          html += '<button class="fl-option" type="button" data-value="' + escapeHtml(subopcao.id) + '">' + escapeHtml(subopcao.rotulo) + '</button>';
        });
        html += '<button class="fl-finder__back" type="button" data-fl-back>' + escapeHtml(this.labels.back || 'Voltar') + '</button>';
      }

      this.options.innerHTML = html;
      this.options.className = 'fl-options';
    }

    showResult() {
      var ranked = this.recommend();
      var direct = ranked
        .filter(function (entry) {
          return entry.direto;
        })
        .slice(0, 8);
      var related = ranked
        .filter(function (entry) {
          return !entry.direto;
        })
        .slice(0, 8);
      var self = this;

      this.heading.textContent = this.labels.resultTitle || '';
      this.question.textContent = this.labels.questionResult || '';
      if (this.topActions) this.topActions.hidden = false;
      this.options.innerHTML = '';
      this.options.hidden = true;

      var directGroup = this.querySelector('[data-fl-direct]');
      var otherGroup = this.querySelector('[data-fl-other]');
      this.querySelector('[data-fl-direct-products]').innerHTML = direct
        .map(function (entry) {
          return self.card(entry.item, 'h4');
        })
        .join('');
      this.querySelector('[data-fl-other-products]').innerHTML = related
        .map(function (entry) {
          return self.card(entry.item, 'h5');
        })
        .join('');
      directGroup.hidden = direct.length === 0;
      otherGroup.hidden = related.length === 0;

      if (ranked.length === 0) {
        if (this.topActions) this.topActions.hidden = true;
        this.options.hidden = false;
        this.options.innerHTML =
          '<p class="fl-help">' + escapeHtml(this.labels.empty || 'Ainda não temos produtos cadastrados para esta escolha. Experimente outro caminho.') + '</p>' +
          '<button class="fl-finder__back" type="button" data-fl-back>' + escapeHtml(this.labels.back || 'Voltar') + '</button>';
        this.result.hidden = true;
        this.step = 1;
        return;
      }

      this.result.hidden = false;
      this.step = 2;
      shortScroll(this.result);
    }
  }

  /* ---------------------------------------------------------------
     Produtos selecionados — "Ver todos" sem recarregar a página.
     Sem JavaScript, todos os produtos continuam visíveis e clicáveis.
  ---------------------------------------------------------------- */
  class FlorescerProducts extends HTMLElement {
    connectedCallback() {
      if (this.dataset.flReady === 'true') return;
      this.dataset.flReady = 'true';

      this.grid = this.querySelector('[data-fl-products-grid]');
      this.toggle = this.querySelector('[data-fl-products-toggle]');
      if (!this.grid || !this.toggle) return;

      this.cards = Array.prototype.slice.call(this.grid.querySelectorAll('.fl-product'));
      this.initial = parseInt(this.dataset.initial, 10);
      if (isNaN(this.initial) || this.initial < 1) this.initial = 8;
      if (this.cards.length <= this.initial) return;

      this.expanded = false;
      this.onToggle = this.onToggle.bind(this);
      this.toggle.hidden = false;
      this.toggle.addEventListener('click', this.onToggle);
      this.apply();
    }

    disconnectedCallback() {
      if (this.dataset.flReady !== 'true') return;
      if (this.toggle && this.onToggle) this.toggle.removeEventListener('click', this.onToggle);
      this.dataset.flReady = 'false';
    }

    apply() {
      var initial = this.initial;
      var expanded = this.expanded;
      this.cards.forEach(function (card, index) {
        card.hidden = !expanded && index >= initial;
      });
      this.toggle.textContent = expanded ? 'Ver menos' : 'Ver todos (' + this.cards.length + ')';
      this.toggle.setAttribute('aria-expanded', String(expanded));
    }

    onToggle() {
      this.expanded = !this.expanded;
      this.apply();
    }
  }

  /* ---------------------------------------------------------------
     Cabeçalho — menu mobile acessível.
  ---------------------------------------------------------------- */
  class FlorescerHeader extends HTMLElement {
    connectedCallback() {
      if (this.dataset.flReady === 'true') return;
      this.dataset.flReady = 'true';

      this.button = this.querySelector('[data-fl-menu-button]');
      this.menu = this.querySelector('[data-fl-menu]');
      if (!this.button || !this.menu) return;

      this.close = this.close.bind(this);
      this.onButtonClick = this.onButtonClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);

      this.button.addEventListener('click', this.onButtonClick);
      this.menu.addEventListener('click', function (event) {
        if (event.target.closest('a')) this.close();
      }.bind(this));
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      if (this.dataset.flReady !== 'true') return;
      if (this.button && this.onButtonClick) this.button.removeEventListener('click', this.onButtonClick);
      document.removeEventListener('keydown', this.onKeydown);
      document.documentElement.style.overflow = '';
      this.dataset.flReady = 'false';
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.close();
    }

    onButtonClick() {
      if (this.button.getAttribute('aria-expanded') === 'true') {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      this.button.setAttribute('aria-expanded', 'true');
      this.button.setAttribute('aria-label', 'Fechar menu');
      this.menu.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var first = this.menu.querySelector('a');
      if (first) first.focus({ preventScroll: true });
    }

    close() {
      if (this.button.getAttribute('aria-expanded') !== 'true') return;
      this.button.setAttribute('aria-expanded', 'false');
      this.button.setAttribute('aria-label', 'Abrir menu');
      this.menu.hidden = true;
      document.documentElement.style.overflow = '';
      this.button.focus({ preventScroll: true });
    }
  }

  function define(name, ctor) {
    if (!customElements.get(name)) customElements.define(name, ctor);
  }

  define('florescer-ways', FlorescerWays);
  define('florescer-finder', FlorescerFinder);
  define('florescer-products', FlorescerProducts);
  define('florescer-header', FlorescerHeader);
})();
